'use client';

import { VpButton, VpIcon, VpIconButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { useAuthenticatedContext } from '@/app/components/Provider';
import { useUserData } from '@/app/hooks/useUserData';
import { Link } from '@/i18n/routing';
import appConst from '~/const/appConst';
import { isAuthenticatedAsMainUser } from '~/utils/user/user';
import { FollowedProjectsIcon } from './FollowedProjectsIcon';

export const EmptyFollowedProject = () => {
  const t = useTranslations();

  const { user, isAuthenticated, redirectToLogin } = useAuthenticatedContext();

  const authenticatedAsMainUser = isAuthenticatedAsMainUser(
    user,
    isAuthenticated,
  );

  const { userData, update } = useUserData({ filter: ['contribution_count'] });

  const { my_participations, projects } = appConst.staticRoutes;

  const authenticatedCallToAction
    = typeof userData?.contribution_count === 'number'
      ? (
          <Link
            className="vp-button vp-button--secondary button-wrapper-link"
            href={userData?.contribution_count ? my_participations : projects}
            prefetch={false}
          >
            <span className="vp-button__label" data-part="label">
              {t(userData?.contribution_count
                ? 'HOMEPAGE.FOLLOWED.ALL_MY_PARTICIPATIONS'
                : 'HOMEPAGE.FOLLOWED.ALL_PROJECTS',
              )}
            </span>
          </Link>
        )
      : (
          <VpButton variant="secondary" disabled>
            <span
              className="vtmn-skeleton vtmn-skeleton_line"
              style={{ width: '240px', height: '24px' }}
            />
          </VpButton>
        );

  const callToAction = !authenticatedAsMainUser
    ? (
        <VpButton
          variant="secondary"
          onClick={async () => await redirectToLogin()}
        >
          {t('GLOBAL.LOGIN_OR_CREATE_ACCOUNT')}
        </VpButton>
      )
    : (
        authenticatedCallToAction
      );

  useEffect(() => {
    update();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="followed-projects__content">
      <div className="followed-projects__animation">
        <FollowedProjectsIcon />
        {!authenticatedAsMainUser
          ? (
              <VpIconButton
                aria-label={t('GLOBAL.LOGIN_OR_CREATE_ACCOUNT')}
                data-testid="participations"
                size="small"
                onClick={async () => await redirectToLogin()}
              >
                <VpIcon name="add" />
              </VpIconButton>
            )
          : (
              <Link
                aria-label={t(userData?.contribution_count
                  ? 'HOMEPAGE.FOLLOWED.ALL_MY_PARTICIPATIONS'
                  : 'HOMEPAGE.FOLLOWED.ALL_PROJECTS',
                )}
                className="vp-icon-button vp-icon-button--small button-wrapper-link"
                href={userData?.contribution_count ? my_participations : projects}
                prefetch={false}
              >
                <VpIcon name="add" />
              </Link>
            )}
      </div>
      <div className="followed-projects__incentive">
        <div className="followed-projects__main-text">
          <h2 className="vp-subtitle-l">{t('HOMEPAGE.NO_FOLLOW.MAIN')}</h2>
          <p className="homepage__secondary-text vp-body-m">
            {t('HOMEPAGE.NO_FOLLOW.SECONDARY')}
          </p>
        </div>
        {callToAction}
      </div>
    </div>
  );
};
